import { fileService } from "@/services/breeze/FileService";
import { File } from "@/types/breeze/File";
import { PaginatedResult } from "@/types/breeze/Any";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export interface UseFilesOptions {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
  enabled?: boolean;
  search?: string;
  fileType?: "image" | "video" | "audio" | "document";
  folderId?: number | null;
}

export function useFiles(options: UseFilesOptions = {}) {
  const {
    page = 1,
    pageSize = 25,
    sortBy,
    sortDirection = "asc",
    enabled = true,
    search,
    fileType,
    folderId,
  } = options;

  return useQuery<PaginatedResult<File>>({
    queryKey: [
      "files",
      { page, pageSize, sortBy, sortDirection, search, fileType, folderId },
    ],
    queryFn: () =>
      fileService.getAll(
        page,
        pageSize,
        sortBy,
        sortDirection,
        search,
        fileType,
        folderId,
      ),
    enabled,
  });
}

export function useDeleteFile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fileId: string) => fileService.deleteFile(fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["files"] });
    },
  });
}
